import { render, staticRenderFns } from "./ChannelSuppliersEdit.vue?vue&type=template&id=4a4d18b2&"
import script from "./ChannelSuppliersEdit.vue?vue&type=script&lang=ts&"
export * from "./ChannelSuppliersEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelSuppliersEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelSuppliersEdit.vue"
export default component.exports